import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  infoBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: '#E0EAFF',
    border: '1px solid #C5D4FF',
  },
  infoBannerCopy: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
    flex: '1 1 auto',
  },
  infoBannerIcon: {
    color: '#0053FF',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoBannerText: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#172024',
    margin: 0,
  },
  urlField: {
    padding: theme.spacing(2, 2.5, 2),
    paddingLeft: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 1.75),
      paddingLeft: theme.spacing(2),
    },
  },
}))

export default useStyles
